import React from 'react'

import {
  FaTwitter,
  FaLinkedin,
  FaStackOverflow,
  FaGithub,
  FaWordpress,
} from 'react-icons/lib/fa'

import me from '../img/me.jpg'
import Hr from '../components/hr'
import social from '../utils/social'

const ICON_SIZE = 30

const IndexPage = () => (
  <div id="intro">
    <img id="avatar" src={me} alt={'Marian Gibala'} />
    <h1>Marian Gibala</h1>
    <p>I'm Full Stack Developer, JS enthusiast and coffee addict.</p>

    <h3>Get in touch</h3>
    <p>
      Say <a href="mailto:marian@mgibala.com">Hi</a> or find me on other
      platforms:{' '}
    </p>

    <div id="social-icons">
      <a href={social.twitter} target="_blank">
        <FaTwitter className="social-icon" size={ICON_SIZE} />
      </a>
      <a href={social.linkedIn} target="_blank">
        {' '}
        <FaLinkedin className="social-icon" size={ICON_SIZE} />
      </a>
      <a href={social.github} target="_blank">
        {' '}
        <FaGithub className="social-icon" size={ICON_SIZE} />
      </a>
      <a href={social.stackOverflow} target="_blank">
        {' '}
        <FaStackOverflow className="social-icon" size={ICON_SIZE} />
      </a>
      <a href={social.hackerRank} target="_blank">
        <Hr className="social-icon" size={ICON_SIZE} />
      </a>
    </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js